import { merchantApiClient } from '../../../../redux'

export const DOWNLOAD_DOCUMENT = '/api/v1/download-document?documentId='

export function downloadDocument(documentId) {
  return merchantApiClient.get(DOWNLOAD_DOCUMENT + documentId, {
    responseType: 'arraybuffer'
  })
}
